module.exports = __webpack_public_path__ + "img/ry-act.32ce556b.png";